module.exports = __webpack_public_path__ + "img/signature.fefe693a.png";